import type { HTMLAttributes } from "react"

import { cn } from "../lib/cn"

interface InputErrorProps extends HTMLAttributes<HTMLParagraphElement> {
  message?: string
}

export function InputError({ message, className, ...props }: InputErrorProps) {
  if (!message) {
    return null
  }

  return (
    <p {...props} className={cn("text-sm text-destructive", className)}>
      {message}
    </p>
  )
}
